import type { SVGProps } from "react";
import * as React from "react";

const SvgIconPipedrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <g clipPath="url(#Icon_pipedrive_svg__a)">
      <path
        fill="#203232"
        d="M71.205-.009h-67a4 4 0 0 0-4 4v67a4 4 0 0 0 4 4h67a4 4 0 0 0 4-4v-67a4 4 0 0 0-4-4"
      />
      <path
        fill="#fff"
        d="M40.756 16.33c-4.367 0-6.914 2.11-8.118 3.587-.14-1.266-.923-2.894-3.918-2.894h-6.578v7.356h2.687c.448 0 .588.15.588.633v33.64h7.781v-12.63c0-.331 0-.663-.028-.934 1.204 1.206 3.527 2.864 7.166 2.864 7.614 0 12.932-6.512 12.932-15.796.056-9.465-5.01-15.826-12.512-15.826M39.16 40.627c-4.198 0-6.102-4.311-6.102-8.32 0-6.3 3.191-8.561 6.214-8.561 3.667 0 6.159 3.406 6.159 8.5-.028 5.818-3.164 8.38-6.27 8.38"
      />
    </g>
    <defs>
      <clipPath id="Icon_pipedrive_svg__a">
        <path
          fill="#fff"
          d="M.205-.009h75v75h-75z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconPipedrive;
